import { type FC } from 'react'

import { type PimVariantAttributeV1 } from '@redteclab/api/clients/bully'

import { type SelectionEntry } from '../../../../product-page-context/AttributeGroup'
import { ProductPageAttributeHead } from '../../ProductPageAttributeHead'
import { ProductPageColorTypeAttributePreview } from '../ProductPageColorTypeAttributePreview'

interface ProductPageColorTypeAttributeHeadProps {
  metaAttribute: PimVariantAttributeV1
  selectedEntry?: SelectionEntry
}

export const ProductPageColorTypeAttributeHead: FC<
  ProductPageColorTypeAttributeHeadProps
> = ({ metaAttribute, selectedEntry }) => {
  return (
    <ProductPageAttributeHead
      metaAttribute={metaAttribute}
      selectedEntry={selectedEntry}
      slotBeforeValue={
        selectedEntry ? (
          <ProductPageColorTypeAttributePreview
            className="border-0"
            selectionEntry={selectedEntry}
          />
        ) : null
      }
    />
  )
}
